export enum RideReason {
  PrivateTrip= 'private-trip',
  Commute= 'commute',
  BusinessTrip= 'business-trip',
}
